module.exports = __webpack_public_path__ + "img/default-avatar.a1c7e317.png";